module.exports = __webpack_public_path__ + "static/media/paintbrush.a69c06f3.jpg";